import axios from 'axios'

const instance = axios.create({
  baseURL: '/',
  timeout: 100000
})
instance.interceptors.response.use(function (response) {
  return response.data
})

export default instance



// WEBPACK FOOTER //
// ./src/utils/request.js